import { useCallback, useEffect } from 'react'
import { RunningContext, zmOnOpenLinkEvent } from '../types/sdk'

export const useOnOpenLink = (runningContext: RunningContext | undefined) => {
  const fn = useCallback((data: zmOnOpenLinkEvent) => {
    if (data && data.type === 'newTab') {
      try {
        zoomSdk.openUrl({ url: data.url })
      } catch {
        //swallow
      }
    }
  }, [])
  useEffect(() => {
    try {
      if (runningContext !== undefined) {
        zoomSdk.addEventListener('zmOnOpenLink', fn)
      }
    } catch {
      // swallow
    }
    return () => {
      try {
        if (runningContext !== undefined)
          zoomSdk.removeEventListener('zmOnOpenLink', fn)
      } catch {
        //swallow
      }
    }
  }, [runningContext, fn])
}
